export function asyncFilter<T>(array:T[], predicate: (item: T) => Promise<boolean>) {
    return Promise.all(array.map(predicate)).then((results) => {
        return array.filter((_, index) => results[index]);
    });
}